<template>
  <div class="student-nutrition-detect">
    <div class="statistics">
      <div class="dame">
        <div class="item date">日期：<a-date-picker size="large" :allowClear='false' v-model="selectedDate" @change="onDateChange" :disabled-date="disabledDate" /></div>
        <div class="item meal">
          餐次：<a-select
            :value='selectedMeal'
            @change="onMealChange"
            style="width: 120px"
            size="large"
          >
            <a-select-option v-for="(item,key) in mealTypes" :value="key" :key="key">{{item}}</a-select-option>
          </a-select>
        </div>
      </div>
      <statistics></statistics>
    </div>
    <class-list></class-list>
  </div>
</template>

<script>
import statistics from '@/components/nutritionMonitor/Statistics'
import classList from '@/components/nutritionMonitor/ClassList'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { mealTypes } from '@/business/enums'
export default {
  inject: ['eventBus'],
  components: {
    statistics,
    classList
  },
  data () {
    return {
      selectedDate: moment(),
      mealTypes
    }
  },
  computed: {
    ...mapState('nutrition', ['selectedMeal'])
  },
  methods: {
    ...mapActions('nutrition', ['saveSelectedMeal']),
    onDateChange (data) {
      this.eventBus.$emit('nutrition-index-date-change', data)
    },
    onMealChange (data) {
      this.saveSelectedMeal(data)
      this.onDateChange(this.selectedDate)
    },
    disabledDate (date) {
      const now = moment()
      const d = this.appIsDemo ? 90 : 15
      if (date <= now && date > now.subtract(d, 'days')) return false
      return true
    }
  },
  created () {
    if (!this.selectedMeal) {
      this.saveSelectedMeal()
    }
  }
}
</script>

<style lang="less">
.student-nutrition-detect {
  .statistics {
    border: 1px solid #e7e7eb;
    background: #fff;
    border-radius: 6px;
    padding: 16px;
    .dame {
      margin-bottom: 16px;
      display: flex;
      .item {
        margin-right: 16px;
      }
    }
    .total-item {
      display: flex;
      text-align: center;
      .item {
        background: #f6f8f9;
        height: 120px;
        overflow: hidden;
        margin-right: 12px;
        padding: 16px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:last-child {
          margin-right: 0;
        }
        &.to {
          width: 160px;
          background: #ebf3fe;
          .text {
            span {
              &::after {
                background: #1b80ec;
              }
            }
          }
          .num {
            .small {
              color: #1b80ec;
            }
          }
        }
        &.no {
          width: 160px;
          background: #f9f4e6;
          .text {
            span {
              &::after {
                background: #e4b207;
              }
            }
          }
          .num {
            .small {
              color: #e4b207;
            }
          }
          .ant-progress-inner {
            background-color: #e6e0cf;
          }
        }
        &.yes {
          background: #eaf9f1;
          flex: 1;
          display: flex;
          align-items: center;
          .text {
            span {
              &::after {
                background: #2fae6f;
              }
            }
          }
          .num {
            .small {
              color: #2fae6f;
            }
          }
          .ant-progress-inner {
            background-color: #d3e3da;
          }
          .yi {
            width: 128px;
          }
          .intake {
            flex: 1;
            display: flex;
            line-height: 1;
            .it {
              flex: 1;
              border-left: 1px solid #d7ebe0;
              &:last-child{
                border-right: 1px solid #d7ebe0;
              }
              .icon {
                width: 36px;
                height: 36px;
                margin: 0 auto 6px;
                img {
                  width: 100%;
                }
              }
              .tn {
                .te{
                  font-size: 13px;
                }
                .nu {
                  margin-top:6px;
                  font-size: 24px;
                  font-weight: bold;
                }
              }
            }
          }
          .chart {
            position: relative;
            margin-left: 16px;
            .text {
              position: absolute;
              left: 0;
              right: 0;
              top: 50%;
              margin-top: -8px;
              text-align: center;
              font-size: 14px;
            }
          }
        }
        .tenu {
          line-height: 1;
          .text {
            span {
              padding-left: 12px;
              position: relative;
              &::after {
                content: "";
                position: absolute;
                left: 0;
                top: 50%;
                width: 8px;
                height: 8px;
                margin-top: -4px;
                border-radius: 50%;
              }
            }
          }
          .num {
            margin-top: 10px;
            .big {
              font-size: 28px;
              font-weight: bold;
            }
            .small {
              font-size: 14px;
            }
            .divider {
              margin: 0 4px;
            }
          }
          .progress {
            margin: 0 auto -8px;
            width: 90px;
          }
        }
      }
    }
  }
  .fili {
    margin-top: 24px;
    border: 1px solid #e7e7eb;
    background: #fff;
    border-radius: 6px;
    padding: 0 16px;
    > .title {
      font-size: 20px;
      padding: 16px 0 12px;
    }
    .filter {
      border-radius: 2px;
      border: 1px solid #e7e7eb;
      padding: 8px 0;
      .item {
        padding: 6px 20px;
        display: flex;
        align-items: center;
        .title {
          font-weight: bold;
          margin-right: 24px;
        }
        .value {
          span {
            display: inline;
            margin-right: 24px;
            &:hover,
            &.active {
              color: #e7c24e;
              cursor: pointer;
            }
          }
        }
      }
    }
    .fun {
      margin-top: 16px;
      display: flex;
      align-items: center;
      .search {
        .ant-input {
          height: 44px;
        }
        .anticon {
          font-size: 18px;
        }
      }
    }
    .list {
      margin: 8px -8px 0;
      .item {
        border: 1px solid #e7e7eb;
        border-radius: 6px;
        margin: 8px;
        cursor: pointer;
        .bd {
          padding: 12px 16px;
          display: flex;
          align-items: flex-end;
          .text {
            flex: 1;
            .class {
              font-size: 16px;
              font-weight: bold;
            }
            .cell {
              margin-top: 2px;
              display: flex;
              align-items: center;
              font-size: 13px;
              .value {
                max-width: 100px;
              }
            }
          }
          .chart {
            margin-left: 21px;
            position: relative;
            .text {
              position: absolute;
              left: 0;
              right: 0;
              top: 50%;
              margin-top: -8px;
              text-align: center;
              font-size: 12px;
            }
          }
        }
        .fd {
          border-top: 1px solid #e7e7eb;
          display: flex;
          padding: 8px 0;
          line-height: 1;
          .cell {
            flex: 1;
            text-align: center;
            border-right: 1px solid #e7e7eb;
            .title {
              color: #999;
              font-size: 13px;
            }
            .value {
              margin-top: 6px;
              font-size: 15px;
            }
            &:last-child {
              border-right: none;
            }
          }
        }
      }
      .pages {
        padding: 4px 12px 16px;
        text-align: center;
      }
    }
  }
}
</style>
